import { useContext } from 'react';
import cx from 'classnames';
import AnnotationContext from "../context/AnnotationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function CircleSubject(_ref) {
  let {
    className,
    x: propsX,
    y: propsY,
    stroke = '#222',
    radius = 16,
    ...restProps
  } = _ref;
  // if props are provided, they take precedence over context
  const annotationContext = useContext(AnnotationContext);
  return /*#__PURE__*/_jsx("circle", {
    className: cx('visx-annotation-subject', 'visx-annotation-subject-circle', className),
    cx: propsX || annotationContext.x,
    cy: propsY || annotationContext.y,
    r: radius,
    fill: "transparent",
    pointerEvents: "none",
    stroke: stroke,
    ...restProps
  });
}